module.exports = __webpack_public_path__ + "static/media/headset.6ec7bf72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/headset.svg
// module id = 92
// module chunks = 0